import React from 'react';
import { Webform } from '@uncinc/react-drupal-core';
import { Container, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const NewsletterBlock = ({ entity }) => {
  const block = entity.toJS();
  const title = block.info[0].value;
  const body = block.body[0].processed;
  const { status, target_id: id } = block.field_webform[0];

  return (
    <div className="BlockNewsletterBlock">
      <Container>
        <div className="row">
          <div className="col-12">
            <div className="BlockNewsletterBlock__title">
              <h2>{title}</h2>
            </div>
          </div>
          <div className="col-12 col-lg-5">
            <div className="BlockNewsletterBlock__body">
              <WysiwygField
                property="schema:text"
                className="TextBlock"
                html={body}
              />
            </div>
          </div>
          <div className="col-12 col-lg-5 offset-lg-2">
            <Webform id={id} status={status} />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default NewsletterBlock;
